function ViewportHalfScrolled() {
	this.build();
}

ViewportHalfScrolled.prototype.build = function () {
	ScrollTrigger.create({
		trigger: ".scroll-content",
		start: function () {
			return window.innerHeight / 2;
		},
		toggleClass: {
			targets: document.body, className: "viewport-half-scrolled"
		}
	});
};
